import { CreditCardOutlined, PaidOutlined, ManageAccountsOutlined, VideocamOutlined } from '@mui/icons-material';
import { supportArticleRoute } from '@uplift/constants';
import { useL10n } from '@uplift/hooks';
import { HelpCenterContainer, HelpCenterTile } from '@uplift/pages';
import { UpliftThemeProvider } from '@uplift/ui-v2';
import { MainLayout } from '../../components';
import { SUPPORT_ARTICLE_SLUGS } from './articles';
import { SupportArticleIndex } from './support-article-index';

const PATIENT_TILES: HelpCenterTile[] = [
  {
    title: 'When will my card on file be charged?',
    description: 'Understand when charges appear on your card.',
    icon: CreditCardOutlined,
    href: supportArticleRoute.createLink({ slug: SUPPORT_ARTICLE_SLUGS.cardOnFileCharges }),
  },
  {
    title: 'How much will I pay for sessions?',
    description: 'Learn what you\'ll owe per session and what insurance covers.',
    icon: PaidOutlined,
    href: supportArticleRoute.createLink({ slug: SUPPORT_ARTICLE_SLUGS.sessionCosts }),
  },
  {
    title: 'How do I change my provider?',
    description: 'Request a new provider match from your dashboard.',
    icon: ManageAccountsOutlined,
    href: supportArticleRoute.createLink({ slug: SUPPORT_ARTICLE_SLUGS.changeProvider }),
  },
  {
    title: 'I\'m having trouble joining my session.',
    description: 'Troubleshoot common video session issues.',
    icon: VideocamOutlined,
    href: supportArticleRoute.createLink({ slug: SUPPORT_ARTICLE_SLUGS.troubleJoiningSession }),
  },
];

export const SupportPage = () => {
  const l10n = useL10n();

  return (
    <MainLayout>
      <UpliftThemeProvider>
        <HelpCenterContainer
          tiles={PATIENT_TILES}
          articleIndex={<SupportArticleIndex />}
          title={l10n.support.pageTitle}
          subtitle={l10n.support.pageSubtitle}
        />
      </UpliftThemeProvider>
    </MainLayout>
  );
};
